/* eslint-disable */
import * as util from "@/api/brandProduct";

const state = {
    isShowForm: false,
    formParamSt: {
        copy:false,
        id: "",
        brand_id: "",
        name: "",
        description: "",
    },
};

const mutations = {
    SET_formParamSt: (state, value) => {
        state.formParamSt = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
};

const actions = {
   
    
    detail({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detail(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    create({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.create(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    update({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.update(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    list({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.list(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    listAgent({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listAgent(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    actFormParamSt({ commit }, data) {
        commit("SET_formParamSt", data);
    },

    deleteData({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteData(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/brandProduct.js